export const benefits = [
    {
        image: "/images/defy-benifits/expert-1.png",
        title: "Licensed Providers",
        description:
            "Our experienced care team is on-hand to review your medical history and symptoms to see which ED medications are right for you.",
    },
    {
        image: "/images/defy-benifits/expert-2.png",
        title: "Subscriptions Available",
        description:
            "Need ED medications regularly? With our subscriptions, you can set it and forget it—plus receive free shipping on your orders over $100. Cancel anytime.",
    },
    {
        image: "/images/defy-benifits/expert-3.png",
        title: "100% Online",
        description:
            "Defy Medical's streamlined process allows you to access ED medications online, with no consultation needed.",
    },
    {
        image: "/images/defy-benifits/expert-4.png",
        title: "Discreet Home Delivery",
        description:
            "Order your medications (if prescribed) and have them delivered in plain packaging to your door.",
    },
    {
        image: "/images/defy-benifits/expert-5.png",
        title: "Expanded Options",
        description:
            "As experts in the field of Men’s Health, we bring you ED options that other clinics don’t offer.",
    },
    {
        image: "/images/defy-benifits/expert-6.png",
        title: "Full Clinic Services",
        description:
            "Through Defy Medical, you can access a suite of telemedicine clinic services to meet your health and wellness needs.",
    },
];
